import { Color, EmitterType, vec, Vector } from 'excalibur';

export const magicMissileParticle = ({ pos = vec(0, 0), width = 2, height = 2 }) => ({
  x: pos.x,
  y: pos.y,
  width,
  height,
  emitterType: EmitterType.Rectangle,
  isEmitting: true,
  emitRate: 30,
  focusAccel: 0,
  particle: {
    minSpeed: 20,
    maxSpeed: 20,
    minAngle: 0,
    maxAngle: 0,
    opacity: 0.9,
    fade: false,
    life: 200,
    minSize: 1,
    maxSize: 2,
    startSize: 2,
    endSize: 1,
    acc: new Vector(0, 0),
    beginColor: Color.Yellow,
    endColor: Color.Yellow,
  },
});

export const arrowParticle = ({ pos = vec(0, 0), width = 1, height = 1 }) => ({
  x: pos.x,
  y: pos.y,
  width,
  height,
  emitterType: EmitterType.Circle,
  isEmitting: true,
  emitRate: 100,
  focusAccel: 0,
  particle: {
    minSpeed: 0,
    maxSpeed: 0,
    minAngle: 0,
    maxAngle: 0,
    opacity: 0.7,
    fade: false,
    life: 50,
    minSize: 1,
    maxSize: 1,
    startSize: 1,
    endSize: 1,
    acc: new Vector(0, 0),
    beginColor: Color.White,
    endColor: Color.White,
  },
});
